module.exports = require('./helpers/bundle-url').getBundleURL('ajLJU') + "logo-dark.eefe0b7f.svg";